
        export enum IconEnum {
            AdobeCreativeCloud = "AdobeCreativeCloud",
AdobeCreativeCloud12 = "AdobeCreativeCloud12",
AdobeCreativeCloud16 = "AdobeCreativeCloud16",
AdobeCreativeCloud20 = "AdobeCreativeCloud20",
AdobeCreativeCloud24 = "AdobeCreativeCloud24",
AdobeCreativeCloud32 = "AdobeCreativeCloud32",
AdobeInDesign = "AdobeInDesign",
AdobeInDesign12 = "AdobeInDesign12",
AdobeInDesign16 = "AdobeInDesign16",
AdobeInDesign20 = "AdobeInDesign20",
AdobeInDesign24 = "AdobeInDesign24",
AdobeInDesign32 = "AdobeInDesign32",
Anchor = "Anchor",
Anchor12 = "Anchor12",
Anchor16 = "Anchor16",
Anchor20 = "Anchor20",
Anchor24 = "Anchor24",
Anchor32 = "Anchor32",
AnnotationLines = "AnnotationLines",
AnnotationLines12 = "AnnotationLines12",
AnnotationLines16 = "AnnotationLines16",
AnnotationLines20 = "AnnotationLines20",
AnnotationLines24 = "AnnotationLines24",
AnnotationLines32 = "AnnotationLines32",
AnnotationNumbers = "AnnotationNumbers",
AnnotationNumbers12 = "AnnotationNumbers12",
AnnotationNumbers16 = "AnnotationNumbers16",
AnnotationNumbers20 = "AnnotationNumbers20",
AnnotationNumbers24 = "AnnotationNumbers24",
AnnotationNumbers32 = "AnnotationNumbers32",
Apps = "Apps",
Apps16 = "Apps16",
Apps20 = "Apps20",
Apps24 = "Apps24",
Apps32 = "Apps32",
Archive = "Archive",
Archive12 = "Archive12",
Archive16 = "Archive16",
Archive20 = "Archive20",
Archive24 = "Archive24",
Archive32 = "Archive32",
ArrowAlignDown = "ArrowAlignDown",
ArrowAlignDown12 = "ArrowAlignDown12",
ArrowAlignDown16 = "ArrowAlignDown16",
ArrowAlignDown20 = "ArrowAlignDown20",
ArrowAlignDown24 = "ArrowAlignDown24",
ArrowAlignDown32 = "ArrowAlignDown32",
ArrowAlignHorizontalCentre = "ArrowAlignHorizontalCentre",
ArrowAlignHorizontalCentre12 = "ArrowAlignHorizontalCentre12",
ArrowAlignHorizontalCentre16 = "ArrowAlignHorizontalCentre16",
ArrowAlignHorizontalCentre20 = "ArrowAlignHorizontalCentre20",
ArrowAlignHorizontalCentre24 = "ArrowAlignHorizontalCentre24",
ArrowAlignHorizontalCentre32 = "ArrowAlignHorizontalCentre32",
ArrowAlignLeft = "ArrowAlignLeft",
ArrowAlignLeft12 = "ArrowAlignLeft12",
ArrowAlignLeft16 = "ArrowAlignLeft16",
ArrowAlignLeft20 = "ArrowAlignLeft20",
ArrowAlignLeft24 = "ArrowAlignLeft24",
ArrowAlignLeft32 = "ArrowAlignLeft32",
ArrowAlignRight = "ArrowAlignRight",
ArrowAlignRight12 = "ArrowAlignRight12",
ArrowAlignRight16 = "ArrowAlignRight16",
ArrowAlignRight20 = "ArrowAlignRight20",
ArrowAlignRight24 = "ArrowAlignRight24",
ArrowAlignRight32 = "ArrowAlignRight32",
ArrowAlignUp = "ArrowAlignUp",
ArrowAlignUp12 = "ArrowAlignUp12",
ArrowAlignUp16 = "ArrowAlignUp16",
ArrowAlignUp20 = "ArrowAlignUp20",
ArrowAlignUp24 = "ArrowAlignUp24",
ArrowAlignUp32 = "ArrowAlignUp32",
ArrowAlignVerticalCentre = "ArrowAlignVerticalCentre",
ArrowAlignVerticalCentre12 = "ArrowAlignVerticalCentre12",
ArrowAlignVerticalCentre16 = "ArrowAlignVerticalCentre16",
ArrowAlignVerticalCentre20 = "ArrowAlignVerticalCentre20",
ArrowAlignVerticalCentre24 = "ArrowAlignVerticalCentre24",
ArrowAlignVerticalCentre32 = "ArrowAlignVerticalCentre32",
ArrowBidirectional = "ArrowBidirectional",
ArrowBidirectional12 = "ArrowBidirectional12",
ArrowBidirectional16 = "ArrowBidirectional16",
ArrowBidirectional20 = "ArrowBidirectional20",
ArrowBidirectional24 = "ArrowBidirectional24",
ArrowBidirectional32 = "ArrowBidirectional32",
ArrowBidirectionalHorizontal = "ArrowBidirectionalHorizontal",
ArrowBidirectionalHorizontal12 = "ArrowBidirectionalHorizontal12",
ArrowBidirectionalHorizontal16 = "ArrowBidirectionalHorizontal16",
ArrowBidirectionalHorizontal20 = "ArrowBidirectionalHorizontal20",
ArrowBidirectionalHorizontal24 = "ArrowBidirectionalHorizontal24",
ArrowBidirectionalHorizontal32 = "ArrowBidirectionalHorizontal32",
ArrowBottomToTop = "ArrowBottomToTop",
ArrowBottomToTop12 = "ArrowBottomToTop12",
ArrowBottomToTop16 = "ArrowBottomToTop16",
ArrowBottomToTop20 = "ArrowBottomToTop20",
ArrowBottomToTop24 = "ArrowBottomToTop24",
ArrowBottomToTop32 = "ArrowBottomToTop32",
ArrowCircleDown = "ArrowCircleDown",
ArrowCircleDown12 = "ArrowCircleDown12",
ArrowCircleDown16 = "ArrowCircleDown16",
ArrowCircleDown20 = "ArrowCircleDown20",
ArrowCircleDown24 = "ArrowCircleDown24",
ArrowCircleDown32 = "ArrowCircleDown32",
ArrowCircleUp = "ArrowCircleUp",
ArrowCircleUp12 = "ArrowCircleUp12",
ArrowCircleUp16 = "ArrowCircleUp16",
ArrowCircleUp20 = "ArrowCircleUp20",
ArrowCircleUp24 = "ArrowCircleUp24",
ArrowCircleUp32 = "ArrowCircleUp32",
ArrowDown = "ArrowDown",
ArrowDown12 = "ArrowDown12",
ArrowDown16 = "ArrowDown16",
ArrowDown20 = "ArrowDown20",
ArrowDown24 = "ArrowDown24",
ArrowDown32 = "ArrowDown32",
ArrowExpand = "ArrowExpand",
ArrowExpand12 = "ArrowExpand12",
ArrowExpand16 = "ArrowExpand16",
ArrowExpand20 = "ArrowExpand20",
ArrowExpand24 = "ArrowExpand24",
ArrowExpand32 = "ArrowExpand32",
ArrowFitBottomLeft = "ArrowFitBottomLeft",
ArrowFitBottomLeft12 = "ArrowFitBottomLeft12",
ArrowFitBottomLeft16 = "ArrowFitBottomLeft16",
ArrowFitBottomLeft20 = "ArrowFitBottomLeft20",
ArrowFitBottomLeft24 = "ArrowFitBottomLeft24",
ArrowFitBottomLeft32 = "ArrowFitBottomLeft32",
ArrowFitBottomRight = "ArrowFitBottomRight",
ArrowFitBottomRight12 = "ArrowFitBottomRight12",
ArrowFitBottomRight16 = "ArrowFitBottomRight16",
ArrowFitBottomRight20 = "ArrowFitBottomRight20",
ArrowFitBottomRight24 = "ArrowFitBottomRight24",
ArrowFitBottomRight32 = "ArrowFitBottomRight32",
ArrowFitTopLeft = "ArrowFitTopLeft",
ArrowFitTopLeft12 = "ArrowFitTopLeft12",
ArrowFitTopLeft16 = "ArrowFitTopLeft16",
ArrowFitTopLeft20 = "ArrowFitTopLeft20",
ArrowFitTopLeft24 = "ArrowFitTopLeft24",
ArrowFitTopLeft32 = "ArrowFitTopLeft32",
ArrowFitTopRight = "ArrowFitTopRight",
ArrowFitTopRight12 = "ArrowFitTopRight12",
ArrowFitTopRight16 = "ArrowFitTopRight16",
ArrowFitTopRight20 = "ArrowFitTopRight20",
ArrowFitTopRight24 = "ArrowFitTopRight24",
ArrowFitTopRight32 = "ArrowFitTopRight32",
ArrowHook = "ArrowHook",
ArrowHook12 = "ArrowHook12",
ArrowHook16 = "ArrowHook16",
ArrowHook20 = "ArrowHook20",
ArrowHook24 = "ArrowHook24",
ArrowHook32 = "ArrowHook32",
ArrowLeft = "ArrowLeft",
ArrowLeft12 = "ArrowLeft12",
ArrowLeft16 = "ArrowLeft16",
ArrowLeft20 = "ArrowLeft20",
ArrowLeft24 = "ArrowLeft24",
ArrowLeft32 = "ArrowLeft32",
ArrowLeftToRight = "ArrowLeftToRight",
ArrowLeftToRight12 = "ArrowLeftToRight12",
ArrowLeftToRight16 = "ArrowLeftToRight16",
ArrowLeftToRight20 = "ArrowLeftToRight20",
ArrowLeftToRight24 = "ArrowLeftToRight24",
ArrowLeftToRight32 = "ArrowLeftToRight32",
ArrowMinimize = "ArrowMinimize",
ArrowMinimize12 = "ArrowMinimize12",
ArrowMinimize16 = "ArrowMinimize16",
ArrowMinimize20 = "ArrowMinimize20",
ArrowMinimize24 = "ArrowMinimize24",
ArrowMinimize32 = "ArrowMinimize32",
ArrowMove = "ArrowMove",
ArrowMove12 = "ArrowMove12",
ArrowMove16 = "ArrowMove16",
ArrowMove20 = "ArrowMove20",
ArrowMove24 = "ArrowMove24",
ArrowMove32 = "ArrowMove32",
ArrowOutExternal = "ArrowOutExternal",
ArrowOutExternal12 = "ArrowOutExternal12",
ArrowOutExternal16 = "ArrowOutExternal16",
ArrowOutExternal20 = "ArrowOutExternal20",
ArrowOutExternal24 = "ArrowOutExternal24",
ArrowOutExternal32 = "ArrowOutExternal32",
ArrowOutLogout = "ArrowOutLogout",
ArrowOutLogout12 = "ArrowOutLogout12",
ArrowOutLogout16 = "ArrowOutLogout16",
ArrowOutLogout20 = "ArrowOutLogout20",
ArrowOutLogout24 = "ArrowOutLogout24",
ArrowOutLogout32 = "ArrowOutLogout32",
ArrowOutShare = "ArrowOutShare",
ArrowOutShare12 = "ArrowOutShare12",
ArrowOutShare16 = "ArrowOutShare16",
ArrowOutShare20 = "ArrowOutShare20",
ArrowOutShare24 = "ArrowOutShare24",
ArrowOutShare32 = "ArrowOutShare32",
ArrowRight = "ArrowRight",
ArrowRight12 = "ArrowRight12",
ArrowRight16 = "ArrowRight16",
ArrowRight20 = "ArrowRight20",
ArrowRight24 = "ArrowRight24",
ArrowRight32 = "ArrowRight32",
ArrowRightToLeft = "ArrowRightToLeft",
ArrowRightToLeft12 = "ArrowRightToLeft12",
ArrowRightToLeft16 = "ArrowRightToLeft16",
ArrowRightToLeft20 = "ArrowRightToLeft20",
ArrowRightToLeft24 = "ArrowRightToLeft24",
ArrowRightToLeft32 = "ArrowRightToLeft32",
ArrowRoundAntiClockwise = "ArrowRoundAntiClockwise",
ArrowRoundAntiClockwise12 = "ArrowRoundAntiClockwise12",
ArrowRoundAntiClockwise16 = "ArrowRoundAntiClockwise16",
ArrowRoundAntiClockwise20 = "ArrowRoundAntiClockwise20",
ArrowRoundAntiClockwise24 = "ArrowRoundAntiClockwise24",
ArrowRoundAntiClockwise32 = "ArrowRoundAntiClockwise32",
ArrowRoundClockwise = "ArrowRoundClockwise",
ArrowRoundClockwise12 = "ArrowRoundClockwise12",
ArrowRoundClockwise16 = "ArrowRoundClockwise16",
ArrowRoundClockwise20 = "ArrowRoundClockwise20",
ArrowRoundClockwise24 = "ArrowRoundClockwise24",
ArrowRoundClockwise32 = "ArrowRoundClockwise32",
ArrowScaleHorizontal = "ArrowScaleHorizontal",
ArrowScaleHorizontal12 = "ArrowScaleHorizontal12",
ArrowScaleHorizontal16 = "ArrowScaleHorizontal16",
ArrowScaleHorizontal20 = "ArrowScaleHorizontal20",
ArrowScaleHorizontal24 = "ArrowScaleHorizontal24",
ArrowScaleHorizontal32 = "ArrowScaleHorizontal32",
ArrowScaleVertical = "ArrowScaleVertical",
ArrowScaleVertical12 = "ArrowScaleVertical12",
ArrowScaleVertical16 = "ArrowScaleVertical16",
ArrowScaleVertical20 = "ArrowScaleVertical20",
ArrowScaleVertical24 = "ArrowScaleVertical24",
ArrowScaleVertical32 = "ArrowScaleVertical32",
ArrowStretchBox = "ArrowStretchBox",
ArrowStretchBox12 = "ArrowStretchBox12",
ArrowStretchBox16 = "ArrowStretchBox16",
ArrowStretchBox20 = "ArrowStretchBox20",
ArrowStretchBox24 = "ArrowStretchBox24",
ArrowStretchBox32 = "ArrowStretchBox32",
ArrowSwap = "ArrowSwap",
ArrowSwap12 = "ArrowSwap12",
ArrowSwap16 = "ArrowSwap16",
ArrowSwap20 = "ArrowSwap20",
ArrowSwap24 = "ArrowSwap24",
ArrowSwap32 = "ArrowSwap32",
ArrowSync = "ArrowSync",
ArrowSync12 = "ArrowSync12",
ArrowSync16 = "ArrowSync16",
ArrowSync20 = "ArrowSync20",
ArrowSync24 = "ArrowSync24",
ArrowSync32 = "ArrowSync32",
ArrowTopToBottom = "ArrowTopToBottom",
ArrowTopToBottom12 = "ArrowTopToBottom12",
ArrowTopToBottom16 = "ArrowTopToBottom16",
ArrowTopToBottom20 = "ArrowTopToBottom20",
ArrowTopToBottom24 = "ArrowTopToBottom24",
ArrowTopToBottom32 = "ArrowTopToBottom32",
ArrowUp = "ArrowUp",
ArrowUp12 = "ArrowUp12",
ArrowUp16 = "ArrowUp16",
ArrowUp20 = "ArrowUp20",
ArrowUp24 = "ArrowUp24",
ArrowUp32 = "ArrowUp32",
Bar = "Bar",
Bar12 = "Bar12",
Bar16 = "Bar16",
Bar20 = "Bar20",
Bar24 = "Bar24",
Bar32 = "Bar32",
BarNarrow = "BarNarrow",
BarNarrow12 = "BarNarrow12",
BarNarrow16 = "BarNarrow16",
BarNarrow20 = "BarNarrow20",
BarNarrow24 = "BarNarrow24",
BarNarrow32 = "BarNarrow32",
Basketball = "Basketball",
Basketball12 = "Basketball12",
Basketball16 = "Basketball16",
Basketball20 = "Basketball20",
Basketball24 = "Basketball24",
Basketball32 = "Basketball32",
Bell = "Bell",
Bell12 = "Bell12",
Bell16 = "Bell16",
Bell20 = "Bell20",
Bell24 = "Bell24",
Bell32 = "Bell32",
Bookmark = "Bookmark",
Bookmark12 = "Bookmark12",
Bookmark12Filled = "Bookmark12Filled",
Bookmark16 = "Bookmark16",
Bookmark16Filled = "Bookmark16Filled",
Bookmark20 = "Bookmark20",
Bookmark20Filled = "Bookmark20Filled",
Bookmark24 = "Bookmark24",
Bookmark24Filled = "Bookmark24Filled",
Bookmark32 = "Bookmark32",
Bookmark32Filled = "Bookmark32Filled",
Box = "Box",
Box12 = "Box12",
Box16 = "Box16",
Box20 = "Box20",
Box24 = "Box24",
Box32 = "Box32",
BracketsCurly = "BracketsCurly",
BracketsCurly12 = "BracketsCurly12",
BracketsCurly16 = "BracketsCurly16",
BracketsCurly20 = "BracketsCurly20",
BracketsCurly24 = "BracketsCurly24",
BracketsCurly32 = "BracketsCurly32",
BuildingBlock = "BuildingBlock",
BuildingBlock12 = "BuildingBlock12",
BuildingBlock16 = "BuildingBlock16",
BuildingBlock20 = "BuildingBlock20",
BuildingBlock24 = "BuildingBlock24",
BuildingBlock32 = "BuildingBlock32",
Buildings = "Buildings",
Buildings12 = "Buildings12",
Buildings16 = "Buildings16",
Buildings20 = "Buildings20",
Buildings24 = "Buildings24",
Buildings32 = "Buildings32",
Button = "Button",
Button12 = "Button12",
Button16 = "Button16",
Button20 = "Button20",
Button24 = "Button24",
Button32 = "Button32",
Calendar = "Calendar",
Calendar12 = "Calendar12",
Calendar16 = "Calendar16",
Calendar20 = "Calendar20",
Calendar24 = "Calendar24",
Calendar32 = "Calendar32",
CalendarChecked = "CalendarChecked",
CalendarChecked12 = "CalendarChecked12",
CalendarChecked16 = "CalendarChecked16",
CalendarChecked20 = "CalendarChecked20",
CalendarChecked24 = "CalendarChecked24",
CalendarChecked32 = "CalendarChecked32",
Camera = "Camera",
Camera12 = "Camera12",
Camera16 = "Camera16",
Camera20 = "Camera20",
Camera24 = "Camera24",
Camera32 = "Camera32",
Cap = "Cap",
Cap12 = "Cap12",
Cap16 = "Cap16",
Cap20 = "Cap20",
Cap24 = "Cap24",
Cap32 = "Cap32",
Card = "Card",
Card12 = "Card12",
Card16 = "Card16",
Card20 = "Card20",
Card24 = "Card24",
Card32 = "Card32",
CardLayoutLarge = "CardLayoutLarge",
CardLayoutLarge12 = "CardLayoutLarge12",
CardLayoutLarge16 = "CardLayoutLarge16",
CardLayoutLarge20 = "CardLayoutLarge20",
CardLayoutLarge24 = "CardLayoutLarge24",
CardLayoutLarge32 = "CardLayoutLarge32",
CardLayoutMedium = "CardLayoutMedium",
CardLayoutMedium12 = "CardLayoutMedium12",
CardLayoutMedium16 = "CardLayoutMedium16",
CardLayoutMedium20 = "CardLayoutMedium20",
CardLayoutMedium24 = "CardLayoutMedium24",
CardLayoutMedium32 = "CardLayoutMedium32",
CardLayoutSmall = "CardLayoutSmall",
CardLayoutSmall12 = "CardLayoutSmall12",
CardLayoutSmall16 = "CardLayoutSmall16",
CardLayoutSmall20 = "CardLayoutSmall20",
CardLayoutSmall24 = "CardLayoutSmall24",
CardLayoutSmall32 = "CardLayoutSmall32",
CaretDown = "CaretDown",
CaretDown12 = "CaretDown12",
CaretDown16 = "CaretDown16",
CaretDown20 = "CaretDown20",
CaretDown24 = "CaretDown24",
CaretDown32 = "CaretDown32",
CaretLeft = "CaretLeft",
CaretLeft12 = "CaretLeft12",
CaretLeft16 = "CaretLeft16",
CaretLeft20 = "CaretLeft20",
CaretLeft24 = "CaretLeft24",
CaretLeft32 = "CaretLeft32",
CaretLeftDouble = "CaretLeftDouble",
CaretLeftDouble12 = "CaretLeftDouble12",
CaretLeftDouble16 = "CaretLeftDouble16",
CaretLeftDouble20 = "CaretLeftDouble20",
CaretLeftDouble24 = "CaretLeftDouble24",
CaretLeftDouble32 = "CaretLeftDouble32",
CaretRight = "CaretRight",
CaretRight12 = "CaretRight12",
CaretRight16 = "CaretRight16",
CaretRight20 = "CaretRight20",
CaretRight24 = "CaretRight24",
CaretRight32 = "CaretRight32",
CaretRightDouble = "CaretRightDouble",
CaretRightDouble12 = "CaretRightDouble12",
CaretRightDouble16 = "CaretRightDouble16",
CaretRightDouble20 = "CaretRightDouble20",
CaretRightDouble24 = "CaretRightDouble24",
CaretRightDouble32 = "CaretRightDouble32",
CaretUp = "CaretUp",
CaretUp12 = "CaretUp12",
CaretUp16 = "CaretUp16",
CaretUp20 = "CaretUp20",
CaretUp24 = "CaretUp24",
CaretUp32 = "CaretUp32",
CaretUpDown = "CaretUpDown",
CaretUpDown12 = "CaretUpDown12",
CaretUpDown16 = "CaretUpDown16",
CaretUpDown20 = "CaretUpDown20",
CaretUpDown24 = "CaretUpDown24",
CaretUpDown32 = "CaretUpDown32",
Carousel = "Carousel",
Carousel12 = "Carousel12",
Carousel16 = "Carousel16",
Carousel20 = "Carousel20",
Carousel24 = "Carousel24",
Carousel32 = "Carousel32",
ChartBars = "ChartBars",
ChartBars12 = "ChartBars12",
ChartBars16 = "ChartBars16",
ChartBars20 = "ChartBars20",
ChartBars24 = "ChartBars24",
ChartBars32 = "ChartBars32",
ChartLine = "ChartLine",
ChartLine12 = "ChartLine12",
ChartLine16 = "ChartLine16",
ChartLine20 = "ChartLine20",
ChartLine24 = "ChartLine24",
ChartLine32 = "ChartLine32",
ChartPie = "ChartPie",
ChartPie12 = "ChartPie12",
ChartPie16 = "ChartPie16",
ChartPie20 = "ChartPie20",
ChartPie24 = "ChartPie24",
ChartPie32 = "ChartPie32",
CheckMark = "CheckMark",
CheckMark12 = "CheckMark12",
CheckMark16 = "CheckMark16",
CheckMark20 = "CheckMark20",
CheckMark24 = "CheckMark24",
CheckMark32 = "CheckMark32",
CheckMarkCircle = "CheckMarkCircle",
CheckMarkCircle12 = "CheckMarkCircle12",
CheckMarkCircle12Filled = "CheckMarkCircle12Filled",
CheckMarkCircle16 = "CheckMarkCircle16",
CheckMarkCircle16Filled = "CheckMarkCircle16Filled",
CheckMarkCircle20 = "CheckMarkCircle20",
CheckMarkCircle20Filled = "CheckMarkCircle20Filled",
CheckMarkCircle24 = "CheckMarkCircle24",
CheckMarkCircle24Filled = "CheckMarkCircle24Filled",
CheckMarkCircle32 = "CheckMarkCircle32",
CheckMarkCircle32Filled = "CheckMarkCircle32Filled",
Checkbox = "Checkbox",
Checkbox12 = "Checkbox12",
Checkbox16 = "Checkbox16",
Checkbox20 = "Checkbox20",
Checkbox24 = "Checkbox24",
Checkbox32 = "Checkbox32",
CheckmarkCircleBox = "CheckmarkCircleBox",
CheckmarkCircleBox12 = "CheckmarkCircleBox12",
CheckmarkCircleBox16 = "CheckmarkCircleBox16",
CheckmarkCircleBox20 = "CheckmarkCircleBox20",
CheckmarkCircleBox24 = "CheckmarkCircleBox24",
CheckmarkCircleBox32 = "CheckmarkCircleBox32",
Circle = "Circle",
Circle12 = "Circle12",
Circle16 = "Circle16",
Circle20 = "Circle20",
Circle24 = "Circle24",
Circle32 = "Circle32",
Clipboard = "Clipboard",
Clipboard12 = "Clipboard12",
Clipboard16 = "Clipboard16",
Clipboard20 = "Clipboard20",
Clipboard24 = "Clipboard24",
Clipboard32 = "Clipboard32",
ClipboardAt = "ClipboardAt",
ClipboardAt12 = "ClipboardAt12",
ClipboardAt16 = "ClipboardAt16",
ClipboardAt20 = "ClipboardAt20",
ClipboardAt24 = "ClipboardAt24",
ClipboardAt32 = "ClipboardAt32",
ClipboardOut = "ClipboardOut",
ClipboardOut12 = "ClipboardOut12",
ClipboardOut16 = "ClipboardOut16",
ClipboardOut20 = "ClipboardOut20",
ClipboardOut24 = "ClipboardOut24",
ClipboardOut32 = "ClipboardOut32",
Clock = "Clock",
Clock12 = "Clock12",
Clock16 = "Clock16",
Clock20 = "Clock20",
Clock24 = "Clock24",
Clock32 = "Clock32",
ClockAlternative = "ClockAlternative",
ClockAlternative12 = "ClockAlternative12",
ClockAlternative16 = "ClockAlternative16",
ClockAlternative20 = "ClockAlternative20",
ClockAlternative24 = "ClockAlternative24",
ClockAlternative32 = "ClockAlternative32",
ClockList = "ClockList",
ClockList12 = "ClockList12",
ClockList16 = "ClockList16",
ClockList20 = "ClockList20",
ClockList24 = "ClockList24",
ClockList32 = "ClockList32",
CloudArrowDown = "CloudArrowDown",
CloudArrowDown12 = "CloudArrowDown12",
CloudArrowDown16 = "CloudArrowDown16",
CloudArrowDown20 = "CloudArrowDown20",
CloudArrowDown24 = "CloudArrowDown24",
CloudArrowDown32 = "CloudArrowDown32",
CloudArrowUp = "CloudArrowUp",
CloudArrowUp12 = "CloudArrowUp12",
CloudArrowUp16 = "CloudArrowUp16",
CloudArrowUp20 = "CloudArrowUp20",
CloudArrowUp24 = "CloudArrowUp24",
CloudArrowUp32 = "CloudArrowUp32",
CloudOff = "CloudOff",
CloudOff12 = "CloudOff12",
CloudOff16 = "CloudOff16",
CloudOff20 = "CloudOff20",
CloudOff24 = "CloudOff24",
CloudOff32 = "CloudOff32",
Code = "Code",
Code12 = "Code12",
Code16 = "Code16",
Code20 = "Code20",
Code24 = "Code24",
Code32 = "Code32",
CodeBox = "CodeBox",
CodeBox12 = "CodeBox12",
CodeBox16 = "CodeBox16",
CodeBox20 = "CodeBox20",
CodeBox24 = "CodeBox24",
CodeBox32 = "CodeBox32",
CodeFrame = "CodeFrame",
CodeFrame12 = "CodeFrame12",
CodeFrame16 = "CodeFrame16",
CodeFrame20 = "CodeFrame20",
CodeFrame24 = "CodeFrame24",
CodeFrame32 = "CodeFrame32",
Cog = "Cog",
Cog12 = "Cog12",
Cog16 = "Cog16",
Cog20 = "Cog20",
Cog24 = "Cog24",
Cog32 = "Cog32",
ColorFan = "ColorFan",
ColorFan12 = "ColorFan12",
ColorFan16 = "ColorFan16",
ColorFan20 = "ColorFan20",
ColorFan24 = "ColorFan24",
ColorFan32 = "ColorFan32",
CommandLineBox = "CommandLineBox",
CommandLineBox12 = "CommandLineBox12",
CommandLineBox16 = "CommandLineBox16",
CommandLineBox20 = "CommandLineBox20",
CommandLineBox24 = "CommandLineBox24",
CommandLineBox32 = "CommandLineBox32",
ContentBlock = "ContentBlock",
ContentBlock12 = "ContentBlock12",
ContentBlock16 = "ContentBlock16",
ContentBlock20 = "ContentBlock20",
ContentBlock24 = "ContentBlock24",
ContentBlock32 = "ContentBlock32",
ContextSearch = "ContextSearch",
ContextSearch12 = "ContextSearch12",
ContextSearch16 = "ContextSearch16",
ContextSearch20 = "ContextSearch20",
ContextSearch24 = "ContextSearch24",
ContextSearch32 = "ContextSearch32",
Controller = "Controller",
Controller12 = "Controller12",
Controller16 = "Controller16",
Controller20 = "Controller20",
Controller24 = "Controller24",
Controller32 = "Controller32",
Country = "Country",
Country12 = "Country12",
Country16 = "Country16",
Country20 = "Country20",
Country24 = "Country24",
Country32 = "Country32",
Crop = "Crop",
Crop12 = "Crop12",
Crop16 = "Crop16",
Crop20 = "Crop20",
Crop24 = "Crop24",
Crop32 = "Crop32",
Cross = "Cross",
Cross12 = "Cross12",
Cross16 = "Cross16",
Cross20 = "Cross20",
Cross24 = "Cross24",
Cross32 = "Cross32",
CrossCircle = "CrossCircle",
CrossCircle12 = "CrossCircle12",
CrossCircle12Filled = "CrossCircle12Filled",
CrossCircle16 = "CrossCircle16",
CrossCircle16Filled = "CrossCircle16Filled",
CrossCircle20 = "CrossCircle20",
CrossCircle20Filled = "CrossCircle20Filled",
CrossCircle24 = "CrossCircle24",
CrossCircle24Filled = "CrossCircle24Filled",
CrossCircle32 = "CrossCircle32",
CrossCircle32Filled = "CrossCircle32Filled",
CrossCircleBox = "CrossCircleBox",
CrossCircleBox12 = "CrossCircleBox12",
CrossCircleBox16 = "CrossCircleBox16",
CrossCircleBox20 = "CrossCircleBox20",
CrossCircleBox24 = "CrossCircleBox24",
CrossCircleBox32 = "CrossCircleBox32",
CursorClick = "CursorClick",
CursorClick12 = "CursorClick12",
CursorClick16 = "CursorClick16",
CursorClick20 = "CursorClick20",
CursorClick24 = "CursorClick24",
CursorClick32 = "CursorClick32",
CurveEasing = "CurveEasing",
CurveEasing12 = "CurveEasing12",
CurveEasing16 = "CurveEasing16",
CurveEasing20 = "CurveEasing20",
CurveEasing24 = "CurveEasing24",
CurveEasing32 = "CurveEasing32",
DesignSystem = "DesignSystem",
DesignSystem12 = "DesignSystem12",
DesignSystem16 = "DesignSystem16",
DesignSystem20 = "DesignSystem20",
DesignSystem24 = "DesignSystem24",
DesignSystem32 = "DesignSystem32",
DiagramTree = "DiagramTree",
DiagramTree12 = "DiagramTree12",
DiagramTree16 = "DiagramTree16",
DiagramTree20 = "DiagramTree20",
DiagramTree24 = "DiagramTree24",
DiagramTree32 = "DiagramTree32",
DividerBlank = "DividerBlank",
DividerBlank12 = "DividerBlank12",
DividerBlank16 = "DividerBlank16",
DividerBlank20 = "DividerBlank20",
DividerBlank24 = "DividerBlank24",
DividerBlank32 = "DividerBlank32",
DividerDashed = "DividerDashed",
DividerDashed12 = "DividerDashed12",
DividerDashed16 = "DividerDashed16",
DividerDashed20 = "DividerDashed20",
DividerDashed24 = "DividerDashed24",
DividerDashed32 = "DividerDashed32",
DividerDotted = "DividerDotted",
DividerDotted12 = "DividerDotted12",
DividerDotted16 = "DividerDotted16",
DividerDotted20 = "DividerDotted20",
DividerDotted24 = "DividerDotted24",
DividerDotted32 = "DividerDotted32",
DividerSolid = "DividerSolid",
DividerSolid12 = "DividerSolid12",
DividerSolid16 = "DividerSolid16",
DividerSolid20 = "DividerSolid20",
DividerSolid24 = "DividerSolid24",
DividerSolid32 = "DividerSolid32",
DoAndDont = "DoAndDont",
DoAndDont12 = "DoAndDont12",
DoAndDont16 = "DoAndDont16",
DoAndDont20 = "DoAndDont20",
DoAndDont24 = "DoAndDont24",
DoAndDont32 = "DoAndDont32",
DoAndDontBox = "DoAndDontBox",
DoAndDontBox12 = "DoAndDontBox12",
DoAndDontBox16 = "DoAndDontBox16",
DoAndDontBox20 = "DoAndDontBox20",
DoAndDontBox24 = "DoAndDontBox24",
DoAndDontBox32 = "DoAndDontBox32",
Document = "Document",
Document12 = "Document12",
Document16 = "Document16",
Document20 = "Document20",
Document24 = "Document24",
Document32 = "Document32",
DocumentArrowRight = "DocumentArrowRight",
DocumentArrowRight12 = "DocumentArrowRight12",
DocumentArrowRight16 = "DocumentArrowRight16",
DocumentArrowRight20 = "DocumentArrowRight20",
DocumentArrowRight24 = "DocumentArrowRight24",
DocumentArrowRight32 = "DocumentArrowRight32",
DocumentBadge = "DocumentBadge",
DocumentBadge12 = "DocumentBadge12",
DocumentBadge16 = "DocumentBadge16",
DocumentBadge20 = "DocumentBadge20",
DocumentBadge24 = "DocumentBadge24",
DocumentBadge32 = "DocumentBadge32",
DocumentCheck = "DocumentCheck",
DocumentCheck12 = "DocumentCheck12",
DocumentCheck16 = "DocumentCheck16",
DocumentCheck20 = "DocumentCheck20",
DocumentCheck24 = "DocumentCheck24",
DocumentCheck32 = "DocumentCheck32",
DocumentCode = "DocumentCode",
DocumentCode12 = "DocumentCode12",
DocumentCode16 = "DocumentCode16",
DocumentCode20 = "DocumentCode20",
DocumentCode24 = "DocumentCode24",
DocumentCode32 = "DocumentCode32",
DocumentList = "DocumentList",
DocumentList12 = "DocumentList12",
DocumentList16 = "DocumentList16",
DocumentList20 = "DocumentList20",
DocumentList24 = "DocumentList24",
DocumentList32 = "DocumentList32",
DocumentStack = "DocumentStack",
DocumentStack12 = "DocumentStack12",
DocumentStack16 = "DocumentStack16",
DocumentStack20 = "DocumentStack20",
DocumentStack24 = "DocumentStack24",
DocumentStack32 = "DocumentStack32",
DocumentText = "DocumentText",
DocumentText12 = "DocumentText12",
DocumentText16 = "DocumentText16",
DocumentText20 = "DocumentText20",
DocumentText24 = "DocumentText24",
DocumentText32 = "DocumentText32",
DotsHorizontal = "DotsHorizontal",
DotsHorizontal12 = "DotsHorizontal12",
DotsHorizontal16 = "DotsHorizontal16",
DotsHorizontal20 = "DotsHorizontal20",
DotsHorizontal24 = "DotsHorizontal24",
DotsHorizontal32 = "DotsHorizontal32",
DotsVertical = "DotsVertical",
DotsVertical12 = "DotsVertical12",
DotsVertical16 = "DotsVertical16",
DotsVertical20 = "DotsVertical20",
DotsVertical24 = "DotsVertical24",
DotsVertical32 = "DotsVertical32",
Droplet = "Droplet",
Droplet12 = "Droplet12",
Droplet16 = "Droplet16",
Droplet20 = "Droplet20",
Droplet24 = "Droplet24",
Droplet32 = "Droplet32",
Drops = "Drops",
Drops12 = "Drops12",
Drops16 = "Drops16",
Drops20 = "Drops20",
Drops24 = "Drops24",
Drops32 = "Drops32",
EdgeAll = "EdgeAll",
EdgeAll12 = "EdgeAll12",
EdgeAll16 = "EdgeAll16",
EdgeAll20 = "EdgeAll20",
EdgeAll24 = "EdgeAll24",
EdgeAll32 = "EdgeAll32",
EdgeBottom = "EdgeBottom",
EdgeBottom12 = "EdgeBottom12",
EdgeBottom16 = "EdgeBottom16",
EdgeBottom20 = "EdgeBottom20",
EdgeBottom24 = "EdgeBottom24",
EdgeBottom32 = "EdgeBottom32",
EdgeLeft = "EdgeLeft",
EdgeLeft12 = "EdgeLeft12",
EdgeLeft16 = "EdgeLeft16",
EdgeLeft20 = "EdgeLeft20",
EdgeLeft24 = "EdgeLeft24",
EdgeLeft32 = "EdgeLeft32",
EdgeRight = "EdgeRight",
EdgeRight12 = "EdgeRight12",
EdgeRight16 = "EdgeRight16",
EdgeRight20 = "EdgeRight20",
EdgeRight24 = "EdgeRight24",
EdgeRight32 = "EdgeRight32",
EdgeTop = "EdgeTop",
EdgeTop12 = "EdgeTop12",
EdgeTop16 = "EdgeTop16",
EdgeTop20 = "EdgeTop20",
EdgeTop24 = "EdgeTop24",
EdgeTop32 = "EdgeTop32",
Envelope = "Envelope",
Envelope12 = "Envelope12",
Envelope16 = "Envelope16",
Envelope20 = "Envelope20",
Envelope24 = "Envelope24",
Envelope32 = "Envelope32",
Eraser = "Eraser",
Eraser12 = "Eraser12",
Eraser16 = "Eraser16",
Eraser20 = "Eraser20",
Eraser24 = "Eraser24",
Eraser32 = "Eraser32",
ExclamationMark = "ExclamationMark",
ExclamationMark12 = "ExclamationMark12",
ExclamationMark16 = "ExclamationMark16",
ExclamationMark20 = "ExclamationMark20",
ExclamationMark24 = "ExclamationMark24",
ExclamationMark32 = "ExclamationMark32",
ExclamationMarkCircle = "ExclamationMarkCircle",
ExclamationMarkCircle12 = "ExclamationMarkCircle12",
ExclamationMarkCircle12Filled = "ExclamationMarkCircle12Filled",
ExclamationMarkCircle16 = "ExclamationMarkCircle16",
ExclamationMarkCircle16Filled = "ExclamationMarkCircle16Filled",
ExclamationMarkCircle20 = "ExclamationMarkCircle20",
ExclamationMarkCircle20Filled = "ExclamationMarkCircle20Filled",
ExclamationMarkCircle24 = "ExclamationMarkCircle24",
ExclamationMarkCircle24Filled = "ExclamationMarkCircle24Filled",
ExclamationMarkCircle32 = "ExclamationMarkCircle32",
ExclamationMarkCircle32Filled = "ExclamationMarkCircle32Filled",
ExclamationMarkTriangle = "ExclamationMarkTriangle",
ExclamationMarkTriangle12 = "ExclamationMarkTriangle12",
ExclamationMarkTriangle16 = "ExclamationMarkTriangle16",
ExclamationMarkTriangle20 = "ExclamationMarkTriangle20",
ExclamationMarkTriangle24 = "ExclamationMarkTriangle24",
ExclamationMarkTriangle32 = "ExclamationMarkTriangle32",
Eye = "Eye",
Eye12 = "Eye12",
Eye16 = "Eye16",
Eye20 = "Eye20",
Eye24 = "Eye24",
Eye32 = "Eye32",
EyeOff = "EyeOff",
EyeOff12 = "EyeOff12",
EyeOff16 = "EyeOff16",
EyeOff20 = "EyeOff20",
EyeOff24 = "EyeOff24",
EyeOff32 = "EyeOff32",
FaceExtraHappy = "FaceExtraHappy",
FaceExtraHappy12 = "FaceExtraHappy12",
FaceExtraHappy16 = "FaceExtraHappy16",
FaceExtraHappy20 = "FaceExtraHappy20",
FaceExtraHappy24 = "FaceExtraHappy24",
FaceExtraHappy32 = "FaceExtraHappy32",
FaceHappy = "FaceHappy",
FaceHappy12 = "FaceHappy12",
FaceHappy12Filled = "FaceHappy12Filled",
FaceHappy16 = "FaceHappy16",
FaceHappy16Filled = "FaceHappy16Filled",
FaceHappy20 = "FaceHappy20",
FaceHappy20Filled = "FaceHappy20Filled",
FaceHappy24 = "FaceHappy24",
FaceHappy24Filled = "FaceHappy24Filled",
FaceHappy32 = "FaceHappy32",
FaceHappy32Filled = "FaceHappy32Filled",
FaceNeutral = "FaceNeutral",
FaceNeutral12 = "FaceNeutral12",
FaceNeutral12Filled = "FaceNeutral12Filled",
FaceNeutral16 = "FaceNeutral16",
FaceNeutral16Filled = "FaceNeutral16Filled",
FaceNeutral20 = "FaceNeutral20",
FaceNeutral20Filled = "FaceNeutral20Filled",
FaceNeutral24 = "FaceNeutral24",
FaceNeutral24Filled = "FaceNeutral24Filled",
FaceNeutral32 = "FaceNeutral32",
FaceNeutral32Filled = "FaceNeutral32Filled",
FaceSad = "FaceSad",
FaceSad12 = "FaceSad12",
FaceSad12Filled = "FaceSad12Filled",
FaceSad16 = "FaceSad16",
FaceSad16Filled = "FaceSad16Filled",
FaceSad20 = "FaceSad20",
FaceSad20Filled = "FaceSad20Filled",
FaceSad24 = "FaceSad24",
FaceSad24Filled = "FaceSad24Filled",
FaceSad32 = "FaceSad32",
FaceSad32Filled = "FaceSad32Filled",
Figma = "Figma",
Figma12 = "Figma12",
Figma16 = "Figma16",
Figma20 = "Figma20",
Figma24 = "Figma24",
Figma32 = "Figma32",
FixedHeight = "FixedHeight",
FixedHeight12 = "FixedHeight12",
FixedHeight16 = "FixedHeight16",
FixedHeight20 = "FixedHeight20",
FixedHeight24 = "FixedHeight24",
FixedHeight32 = "FixedHeight32",
FixedWidth = "FixedWidth",
FixedWidth12 = "FixedWidth12",
FixedWidth16 = "FixedWidth16",
FixedWidth20 = "FixedWidth20",
FixedWidth24 = "FixedWidth24",
FixedWidth32 = "FixedWidth32",
Flag = "Flag",
Flag12 = "Flag12",
Flag16 = "Flag16",
Flag20 = "Flag20",
Flag24 = "Flag24",
Flag32 = "Flag32",
FlipHorizontally = "FlipHorizontally",
FlipHorizontally12 = "FlipHorizontally12",
FlipHorizontally16 = "FlipHorizontally16",
FlipHorizontally20 = "FlipHorizontally20",
FlipHorizontally24 = "FlipHorizontally24",
FlipHorizontally32 = "FlipHorizontally32",
FlipVertically = "FlipVertically",
FlipVertically12 = "FlipVertically12",
FlipVertically16 = "FlipVertically16",
FlipVertically20 = "FlipVertically20",
FlipVertically24 = "FlipVertically24",
FlipVertically32 = "FlipVertically32",
FocalPoint = "FocalPoint",
FocalPoint12 = "FocalPoint12",
FocalPoint16 = "FocalPoint16",
FocalPoint20 = "FocalPoint20",
FocalPoint24 = "FocalPoint24",
FocalPoint32 = "FocalPoint32",
Folder = "Folder",
Folder12 = "Folder12",
Folder16 = "Folder16",
Folder20 = "Folder20",
Folder24 = "Folder24",
Folder32 = "Folder32",
FolderArrowRight = "FolderArrowRight",
FolderArrowRight12 = "FolderArrowRight12",
FolderArrowRight16 = "FolderArrowRight16",
FolderArrowRight20 = "FolderArrowRight20",
FolderArrowRight24 = "FolderArrowRight24",
FolderArrowRight32 = "FolderArrowRight32",
FolderArrowUp = "FolderArrowUp",
FolderArrowUp12 = "FolderArrowUp12",
FolderArrowUp16 = "FolderArrowUp16",
FolderArrowUp20 = "FolderArrowUp20",
FolderArrowUp24 = "FolderArrowUp24",
FolderArrowUp32 = "FolderArrowUp32",
Folders = "Folders",
Folders12 = "Folders12",
Folders16 = "Folders16",
Folders20 = "Folders20",
Folders24 = "Folders24",
Folders32 = "Folders32",
Footer = "Footer",
Footer12 = "Footer12",
Footer16 = "Footer16",
Footer20 = "Footer20",
Footer24 = "Footer24",
Footer32 = "Footer32",
Funnel = "Funnel",
Funnel12 = "Funnel12",
Funnel16 = "Funnel16",
Funnel20 = "Funnel20",
Funnel24 = "Funnel24",
Funnel32 = "Funnel32",
GrabHandle = "GrabHandle",
GrabHandle12 = "GrabHandle12",
GrabHandle16 = "GrabHandle16",
GrabHandle20 = "GrabHandle20",
GrabHandle24 = "GrabHandle24",
GrabHandle32 = "GrabHandle32",
Gradient = "Gradient",
Gradient12 = "Gradient12",
Gradient16 = "Gradient16",
Gradient20 = "Gradient20",
Gradient24 = "Gradient24",
Gradient32 = "Gradient32",
GridRegular = "GridRegular",
GridRegular12 = "GridRegular12",
GridRegular12Filled = "GridRegular12Filled",
GridRegular16 = "GridRegular16",
GridRegular16Filled = "GridRegular16Filled",
GridRegular20 = "GridRegular20",
GridRegular20Filled = "GridRegular20Filled",
GridRegular24 = "GridRegular24",
GridRegular24Filled = "GridRegular24Filled",
GridRegular32 = "GridRegular32",
GridRegular32Filled = "GridRegular32Filled",
GutterHorizontal = "GutterHorizontal",
GutterHorizontal12 = "GutterHorizontal12",
GutterHorizontal16 = "GutterHorizontal16",
GutterHorizontal20 = "GutterHorizontal20",
GutterHorizontal24 = "GutterHorizontal24",
GutterHorizontal32 = "GutterHorizontal32",
GutterVertical = "GutterVertical",
GutterVertical12 = "GutterVertical12",
GutterVertical16 = "GutterVertical16",
GutterVertical20 = "GutterVertical20",
GutterVertical24 = "GutterVertical24",
GutterVertical32 = "GutterVertical32",
H = "H",
H12 = "H12",
H16 = "H16",
H20 = "H20",
H24 = "H24",
H32 = "H32",
Hashtag = "Hashtag",
Hashtag12 = "Hashtag12",
Hashtag16 = "Hashtag16",
Hashtag20 = "Hashtag20",
Hashtag24 = "Hashtag24",
Hashtag32 = "Hashtag32",
Heading = "Heading",
Heading12 = "Heading12",
Heading16 = "Heading16",
Heading20 = "Heading20",
Heading24 = "Heading24",
Heading32 = "Heading32",
HeartCircle = "HeartCircle",
HeartCircle12 = "HeartCircle12",
HeartCircle16 = "HeartCircle16",
HeartCircle20 = "HeartCircle20",
HeartCircle24 = "HeartCircle24",
HeartCircle32 = "HeartCircle32",
HeartCircleStack = "HeartCircleStack",
HeartCircleStack12 = "HeartCircleStack12",
HeartCircleStack16 = "HeartCircleStack16",
HeartCircleStack20 = "HeartCircleStack20",
HeartCircleStack24 = "HeartCircleStack24",
HeartCircleStack32 = "HeartCircleStack32",
Highlighter = "Highlighter",
Highlighter12 = "Highlighter12",
Highlighter16 = "Highlighter16",
Highlighter20 = "Highlighter20",
Highlighter24 = "Highlighter24",
Highlighter32 = "Highlighter32",
Home = "Home",
Home12 = "Home12",
Home16 = "Home16",
Home20 = "Home20",
Home24 = "Home24",
Home32 = "Home32",
Hub = "Hub",
Hub12 = "Hub12",
Hub16 = "Hub16",
Hub20 = "Hub20",
Hub24 = "Hub24",
Hub32 = "Hub32",
Icon = "Icon",
Icon12 = "Icon12",
Icon16 = "Icon16",
Icon20 = "Icon20",
Icon24 = "Icon24",
Icon32 = "Icon32",
IconShape = "IconShape",
IconShape12 = "IconShape12",
IconShape16 = "IconShape16",
IconShape20 = "IconShape20",
IconShape24 = "IconShape24",
IconShape32 = "IconShape32",
Image = "Image",
Image12 = "Image12",
Image16 = "Image16",
Image20 = "Image20",
Image24 = "Image24",
Image32 = "Image32",
ImageStack = "ImageStack",
ImageStack12 = "ImageStack12",
ImageStack16 = "ImageStack16",
ImageStack20 = "ImageStack20",
ImageStack24 = "ImageStack24",
ImageStack32 = "ImageStack32",
ImageStackPlus = "ImageStackPlus",
ImageStackPlus12 = "ImageStackPlus12",
ImageStackPlus16 = "ImageStackPlus16",
ImageStackPlus20 = "ImageStackPlus20",
ImageStackPlus24 = "ImageStackPlus24",
ImageStackPlus32 = "ImageStackPlus32",
ImageWithText = "ImageWithText",
ImageWithText12 = "ImageWithText12",
ImageWithText16 = "ImageWithText16",
ImageWithText20 = "ImageWithText20",
ImageWithText24 = "ImageWithText24",
ImageWithText32 = "ImageWithText32",
Info = "Info",
Info12 = "Info12",
Info16 = "Info16",
Info20 = "Info20",
Info24 = "Info24",
Info32 = "Info32",
Intercom = "Intercom",
Intercom12 = "Intercom12",
Intercom16 = "Intercom16",
Intercom20 = "Intercom20",
Intercom24 = "Intercom24",
Intercom32 = "Intercom32",
Johanna = "Johanna",
Johanna12 = "Johanna12",
Johanna16 = "Johanna16",
Johanna20 = "Johanna20",
Johanna24 = "Johanna24",
Johanna32 = "Johanna32",
Label = "Label",
Label12 = "Label12",
Label16 = "Label16",
Label20 = "Label20",
Label24 = "Label24",
Label32 = "Label32",
Language = "Language",
Language12 = "Language12",
Language16 = "Language16",
Language20 = "Language20",
Language24 = "Language24",
Language32 = "Language32",
Layers = "Layers",
Layers12 = "Layers12",
Layers16 = "Layers16",
Layers20 = "Layers20",
Layers24 = "Layers24",
Layers32 = "Layers32",
LayersSingle = "LayersSingle",
LayersSingle12 = "LayersSingle12",
LayersSingle16 = "LayersSingle16",
LayersSingle20 = "LayersSingle20",
LayersSingle24 = "LayersSingle24",
LayersSingle32 = "LayersSingle32",
Leaf = "Leaf",
Leaf12 = "Leaf12",
Leaf16 = "Leaf16",
Leaf20 = "Leaf20",
Leaf24 = "Leaf24",
Leaf32 = "Leaf32",
Lightbulb = "Lightbulb",
Lightbulb12 = "Lightbulb12",
Lightbulb16 = "Lightbulb16",
Lightbulb20 = "Lightbulb20",
Lightbulb24 = "Lightbulb24",
Lightbulb32 = "Lightbulb32",
Lightning = "Lightning",
Lightning12 = "Lightning12",
Lightning12Filled = "Lightning12Filled",
Lightning16 = "Lightning16",
Lightning16Filled = "Lightning16Filled",
Lightning20 = "Lightning20",
Lightning20Filled = "Lightning20Filled",
Lightning24 = "Lightning24",
Lightning24Filled = "Lightning24Filled",
Lightning32 = "Lightning32",
Lightning32Filled = "Lightning32Filled",
Lines = "Lines",
Lines12 = "Lines12",
Lines16 = "Lines16",
Lines20 = "Lines20",
Lines24 = "Lines24",
Lines32 = "Lines32",
LinesTriangular = "LinesTriangular",
LinesTriangular12 = "LinesTriangular12",
LinesTriangular16 = "LinesTriangular16",
LinesTriangular20 = "LinesTriangular20",
LinesTriangular24 = "LinesTriangular24",
LinesTriangular32 = "LinesTriangular32",
Link = "Link",
Link12 = "Link12",
Link16 = "Link16",
Link20 = "Link20",
Link24 = "Link24",
Link32 = "Link32",
LinkBox = "LinkBox",
LinkBox12 = "LinkBox12",
LinkBox16 = "LinkBox16",
LinkBox20 = "LinkBox20",
LinkBox24 = "LinkBox24",
LinkBox32 = "LinkBox32",
LinkOpen = "LinkOpen",
LinkOpen12 = "LinkOpen12",
LinkOpen16 = "LinkOpen16",
LinkOpen20 = "LinkOpen20",
LinkOpen24 = "LinkOpen24",
LinkOpen32 = "LinkOpen32",
ListBullet = "ListBullet",
ListBullet12 = "ListBullet12",
ListBullet16 = "ListBullet16",
ListBullet20 = "ListBullet20",
ListBullet24 = "ListBullet24",
ListBullet32 = "ListBullet32",
ListCheck = "ListCheck",
ListCheck12 = "ListCheck12",
ListCheck16 = "ListCheck16",
ListCheck20 = "ListCheck20",
ListCheck24 = "ListCheck24",
ListCheck32 = "ListCheck32",
ListIndented = "ListIndented",
ListIndented12 = "ListIndented12",
ListIndented16 = "ListIndented16",
ListIndented20 = "ListIndented20",
ListIndented24 = "ListIndented24",
ListIndented32 = "ListIndented32",
ListNumbers = "ListNumbers",
ListNumbers12 = "ListNumbers12",
ListNumbers16 = "ListNumbers16",
ListNumbers20 = "ListNumbers20",
ListNumbers24 = "ListNumbers24",
ListNumbers32 = "ListNumbers32",
LockClosed = "LockClosed",
LockClosed12 = "LockClosed12",
LockClosed16 = "LockClosed16",
LockClosed20 = "LockClosed20",
LockClosed24 = "LockClosed24",
LockClosed32 = "LockClosed32",
LockOpen = "LockOpen",
LockOpen12 = "LockOpen12",
LockOpen12Filled = "LockOpen12Filled",
LockOpen16 = "LockOpen16",
LockOpen16Filled = "LockOpen16Filled",
LockOpen20 = "LockOpen20",
LockOpen20Filled = "LockOpen20Filled",
LockOpen24 = "LockOpen24",
LockOpen24Filled = "LockOpen24Filled",
LockOpen32 = "LockOpen32",
LockOpen32Filled = "LockOpen32Filled",
Lollipop = "Lollipop",
Lollipop12 = "Lollipop12",
Lollipop16 = "Lollipop16",
Lollipop20 = "Lollipop20",
Lollipop24 = "Lollipop24",
Lollipop32 = "Lollipop32",
Magnifier = "Magnifier",
Magnifier12 = "Magnifier12",
Magnifier16 = "Magnifier16",
Magnifier20 = "Magnifier20",
Magnifier24 = "Magnifier24",
Magnifier32 = "Magnifier32",
MagnifierPlus = "MagnifierPlus",
MagnifierPlus12 = "MagnifierPlus12",
MagnifierPlus16 = "MagnifierPlus16",
MagnifierPlus20 = "MagnifierPlus20",
MagnifierPlus24 = "MagnifierPlus24",
MagnifierPlus32 = "MagnifierPlus32",
MapPointer = "MapPointer",
MapPointer12 = "MapPointer12",
MapPointer16 = "MapPointer16",
MapPointer20 = "MapPointer20",
MapPointer24 = "MapPointer24",
MapPointer32 = "MapPointer32",
MarginBottom = "MarginBottom",
MarginBottom12 = "MarginBottom12",
MarginBottom16 = "MarginBottom16",
MarginBottom20 = "MarginBottom20",
MarginBottom24 = "MarginBottom24",
MarginBottom32 = "MarginBottom32",
MarginLeft = "MarginLeft",
MarginLeft12 = "MarginLeft12",
MarginLeft16 = "MarginLeft16",
MarginLeft20 = "MarginLeft20",
MarginLeft24 = "MarginLeft24",
MarginLeft32 = "MarginLeft32",
MarginRight = "MarginRight",
MarginRight12 = "MarginRight12",
MarginRight16 = "MarginRight16",
MarginRight20 = "MarginRight20",
MarginRight24 = "MarginRight24",
MarginRight32 = "MarginRight32",
MarginTop = "MarginTop",
MarginTop12 = "MarginTop12",
MarginTop16 = "MarginTop16",
MarginTop20 = "MarginTop20",
MarginTop24 = "MarginTop24",
MarginTop32 = "MarginTop32",
MarkArea = "MarkArea",
MarkArea12 = "MarkArea12",
MarkArea16 = "MarkArea16",
MarkArea20 = "MarkArea20",
MarkArea24 = "MarkArea24",
MarkArea32 = "MarkArea32",
Market = "Market",
Market12 = "Market12",
Market16 = "Market16",
Market20 = "Market20",
Market24 = "Market24",
Market32 = "Market32",
Masonry = "Masonry",
Masonry12 = "Masonry12",
Masonry16 = "Masonry16",
Masonry20 = "Masonry20",
Masonry24 = "Masonry24",
Masonry32 = "Masonry32",
MediaObject = "MediaObject",
MediaObject12 = "MediaObject12",
MediaObject16 = "MediaObject16",
MediaObject20 = "MediaObject20",
MediaObject24 = "MediaObject24",
MediaObject32 = "MediaObject32",
MediaObjectIcon = "MediaObjectIcon",
MediaObjectIcon12 = "MediaObjectIcon12",
MediaObjectIcon16 = "MediaObjectIcon16",
MediaObjectIcon20 = "MediaObjectIcon20",
MediaObjectIcon24 = "MediaObjectIcon24",
MediaObjectIcon32 = "MediaObjectIcon32",
MediaObjectImage = "MediaObjectImage",
MediaObjectImage12 = "MediaObjectImage12",
MediaObjectImage16 = "MediaObjectImage16",
MediaObjectImage20 = "MediaObjectImage20",
MediaObjectImage24 = "MediaObjectImage24",
MediaObjectImage32 = "MediaObjectImage32",
MediaObjectRatio1To1 = "MediaObjectRatio1To1",
MediaObjectRatio1To112 = "MediaObjectRatio1To112",
MediaObjectRatio1To116 = "MediaObjectRatio1To116",
MediaObjectRatio1To120 = "MediaObjectRatio1To120",
MediaObjectRatio1To124 = "MediaObjectRatio1To124",
MediaObjectRatio1To132 = "MediaObjectRatio1To132",
MediaObjectRatio1To2 = "MediaObjectRatio1To2",
MediaObjectRatio1To212 = "MediaObjectRatio1To212",
MediaObjectRatio1To216 = "MediaObjectRatio1To216",
MediaObjectRatio1To220 = "MediaObjectRatio1To220",
MediaObjectRatio1To224 = "MediaObjectRatio1To224",
MediaObjectRatio1To232 = "MediaObjectRatio1To232",
MediaObjectRatio1To3 = "MediaObjectRatio1To3",
MediaObjectRatio1To312 = "MediaObjectRatio1To312",
MediaObjectRatio1To316 = "MediaObjectRatio1To316",
MediaObjectRatio1To320 = "MediaObjectRatio1To320",
MediaObjectRatio1To324 = "MediaObjectRatio1To324",
MediaObjectRatio1To332 = "MediaObjectRatio1To332",
MediaObjectRatio2To1 = "MediaObjectRatio2To1",
MediaObjectRatio2To112 = "MediaObjectRatio2To112",
MediaObjectRatio2To116 = "MediaObjectRatio2To116",
MediaObjectRatio2To120 = "MediaObjectRatio2To120",
MediaObjectRatio2To124 = "MediaObjectRatio2To124",
MediaObjectRatio2To132 = "MediaObjectRatio2To132",
MediaObjectRatio3To1 = "MediaObjectRatio3To1",
MediaObjectRatio3To112 = "MediaObjectRatio3To112",
MediaObjectRatio3To116 = "MediaObjectRatio3To116",
MediaObjectRatio3To120 = "MediaObjectRatio3To120",
MediaObjectRatio3To124 = "MediaObjectRatio3To124",
MediaObjectRatio3To132 = "MediaObjectRatio3To132",
MediaObjectTextBottom = "MediaObjectTextBottom",
MediaObjectTextBottom12 = "MediaObjectTextBottom12",
MediaObjectTextBottom16 = "MediaObjectTextBottom16",
MediaObjectTextBottom20 = "MediaObjectTextBottom20",
MediaObjectTextBottom24 = "MediaObjectTextBottom24",
MediaObjectTextBottom32 = "MediaObjectTextBottom32",
MediaObjectTextLeft = "MediaObjectTextLeft",
MediaObjectTextLeft12 = "MediaObjectTextLeft12",
MediaObjectTextLeft16 = "MediaObjectTextLeft16",
MediaObjectTextLeft20 = "MediaObjectTextLeft20",
MediaObjectTextLeft24 = "MediaObjectTextLeft24",
MediaObjectTextLeft32 = "MediaObjectTextLeft32",
MediaObjectTextRight = "MediaObjectTextRight",
MediaObjectTextRight12 = "MediaObjectTextRight12",
MediaObjectTextRight16 = "MediaObjectTextRight16",
MediaObjectTextRight20 = "MediaObjectTextRight20",
MediaObjectTextRight24 = "MediaObjectTextRight24",
MediaObjectTextRight32 = "MediaObjectTextRight32",
MediaObjectTextTop = "MediaObjectTextTop",
MediaObjectTextTop12 = "MediaObjectTextTop12",
MediaObjectTextTop16 = "MediaObjectTextTop16",
MediaObjectTextTop20 = "MediaObjectTextTop20",
MediaObjectTextTop24 = "MediaObjectTextTop24",
MediaObjectTextTop32 = "MediaObjectTextTop32",
MediaObjectVideo = "MediaObjectVideo",
MediaObjectVideo12 = "MediaObjectVideo12",
MediaObjectVideo16 = "MediaObjectVideo16",
MediaObjectVideo20 = "MediaObjectVideo20",
MediaObjectVideo24 = "MediaObjectVideo24",
MediaObjectVideo32 = "MediaObjectVideo32",
MegaMenu = "MegaMenu",
MegaMenu12 = "MegaMenu12",
MegaMenu16 = "MegaMenu16",
MegaMenu20 = "MegaMenu20",
MegaMenu24 = "MegaMenu24",
MegaMenu32 = "MegaMenu32",
Megaphone = "Megaphone",
Megaphone12 = "Megaphone12",
Megaphone16 = "Megaphone16",
Megaphone20 = "Megaphone20",
Megaphone24 = "Megaphone24",
Megaphone32 = "Megaphone32",
Microphone = "Microphone",
Microphone12 = "Microphone12",
Microphone16 = "Microphone16",
Microphone20 = "Microphone20",
Microphone24 = "Microphone24",
Microphone32 = "Microphone32",
Minus = "Minus",
Minus12 = "Minus12",
Minus16 = "Minus16",
Minus20 = "Minus20",
Minus24 = "Minus24",
Minus32 = "Minus32",
MinusCircle = "MinusCircle",
MinusCircle12 = "MinusCircle12",
MinusCircle16 = "MinusCircle16",
MinusCircle20 = "MinusCircle20",
MinusCircle24 = "MinusCircle24",
MinusCircle32 = "MinusCircle32",
Money = "Money",
Money12 = "Money12",
Money16 = "Money16",
Money20 = "Money20",
Money24 = "Money24",
Money32 = "Money32",
MoneyCircle = "MoneyCircle",
MoneyCircle12Filled = "MoneyCircle12Filled",
MoneyCircle16Filled = "MoneyCircle16Filled",
MoneyCircle20Filled = "MoneyCircle20Filled",
MoneyCircle24Filled = "MoneyCircle24Filled",
MoneyCircle32Filled = "MoneyCircle32Filled",
MoveTo = "MoveTo",
MoveTo12 = "MoveTo12",
MoveTo16 = "MoveTo16",
MoveTo20 = "MoveTo20",
MoveTo24 = "MoveTo24",
MoveTo32 = "MoveTo32",
MusicNote = "MusicNote",
MusicNote12 = "MusicNote12",
MusicNote16 = "MusicNote16",
MusicNote20 = "MusicNote20",
MusicNote24 = "MusicNote24",
MusicNote32 = "MusicNote32",
Nook = "Nook",
Nook12 = "Nook12",
Nook16 = "Nook16",
Nook20 = "Nook20",
Nook24 = "Nook24",
Nook32 = "Nook32",
OpenAi = "OpenAi",
OpenAi12 = "OpenAi12",
OpenAi16 = "OpenAi16",
OpenAi20 = "OpenAi20",
OpenAi24 = "OpenAi24",
OpenAi32 = "OpenAi32",
OrientationBoxes = "OrientationBoxes",
OrientationBoxes12 = "OrientationBoxes12",
OrientationBoxes16 = "OrientationBoxes16",
OrientationBoxes20 = "OrientationBoxes20",
OrientationBoxes24 = "OrientationBoxes24",
OrientationBoxes32 = "OrientationBoxes32",
PaddingHorizontal = "PaddingHorizontal",
PaddingHorizontal12 = "PaddingHorizontal12",
PaddingHorizontal16 = "PaddingHorizontal16",
PaddingHorizontal20 = "PaddingHorizontal20",
PaddingHorizontal24 = "PaddingHorizontal24",
PaddingHorizontal32 = "PaddingHorizontal32",
PaddingVertical = "PaddingVertical",
PaddingVertical12 = "PaddingVertical12",
PaddingVertical16 = "PaddingVertical16",
PaddingVertical20 = "PaddingVertical20",
PaddingVertical24 = "PaddingVertical24",
PaddingVertical32 = "PaddingVertical32",
Paintbrush = "Paintbrush",
Paintbrush12 = "Paintbrush12",
Paintbrush16 = "Paintbrush16",
Paintbrush20 = "Paintbrush20",
Paintbrush24 = "Paintbrush24",
Paintbrush32 = "Paintbrush32",
Paperclip = "Paperclip",
Paperclip12 = "Paperclip12",
Paperclip16 = "Paperclip16",
Paperclip20 = "Paperclip20",
Paperclip24 = "Paperclip24",
Paperclip32 = "Paperclip32",
Paperplane = "Paperplane",
Paperplane12 = "Paperplane12",
Paperplane16 = "Paperplane16",
Paperplane20 = "Paperplane20",
Paperplane24 = "Paperplane24",
Paperplane32 = "Paperplane32",
Pause = "Pause",
Pause12 = "Pause12",
Pause12Filled = "Pause12Filled",
Pause16 = "Pause16",
Pause16Filled = "Pause16Filled",
Pause20 = "Pause20",
Pause20Filled = "Pause20Filled",
Pause24 = "Pause24",
Pause24Filled = "Pause24Filled",
Pause32 = "Pause32",
Pause32Filled = "Pause32Filled",
Pen = "Pen",
Pen12 = "Pen12",
Pen16 = "Pen16",
Pen20 = "Pen20",
Pen24 = "Pen24",
Pen32 = "Pen32",
People = "People",
People12 = "People12",
People16 = "People16",
People20 = "People20",
People24 = "People24",
People32 = "People32",
Person = "Person",
Person12 = "Person12",
Person16 = "Person16",
Person20 = "Person20",
Person24 = "Person24",
Person32 = "Person32",
PersonAnonymous = "PersonAnonymous",
PersonAnonymous12 = "PersonAnonymous12",
PersonAnonymous16 = "PersonAnonymous16",
PersonAnonymous20 = "PersonAnonymous20",
PersonAnonymous24 = "PersonAnonymous24",
PersonAnonymous32 = "PersonAnonymous32",
PersonLock = "PersonLock",
PersonLock12 = "PersonLock12",
PersonLock16 = "PersonLock16",
PersonLock20 = "PersonLock20",
PersonLock24 = "PersonLock24",
PersonLock32 = "PersonLock32",
PersonSlash = "PersonSlash",
PersonSlash12 = "PersonSlash12",
PersonSlash16 = "PersonSlash16",
PersonSlash20 = "PersonSlash20",
PersonSlash24 = "PersonSlash24",
PersonSlash32 = "PersonSlash32",
Pills = "Pills",
Pills12 = "Pills12",
Pills16 = "Pills16",
Pills20 = "Pills20",
Pills24 = "Pills24",
Pills32 = "Pills32",
Pin = "Pin",
Pin12 = "Pin12",
Pin12Filled = "Pin12Filled",
Pin16 = "Pin16",
Pin16Filled = "Pin16Filled",
Pin20 = "Pin20",
Pin20Filled = "Pin20Filled",
Pin24 = "Pin24",
Pin24Filled = "Pin24Filled",
Pin32 = "Pin32",
Pin32Filled = "Pin32Filled",
Play = "Play",
Play12 = "Play12",
Play12Filled = "Play12Filled",
Play16 = "Play16",
Play16Filled = "Play16Filled",
Play20 = "Play20",
Play20Filled = "Play20Filled",
Play24 = "Play24",
Play24Filled = "Play24Filled",
Play32 = "Play32",
Play32Filled = "Play32Filled",
PlayBox = "PlayBox",
PlayBox12 = "PlayBox12",
PlayBox16 = "PlayBox16",
PlayBox20 = "PlayBox20",
PlayBox24 = "PlayBox24",
PlayBox32 = "PlayBox32",
PlayCircle = "PlayCircle",
PlayCircle12 = "PlayCircle12",
PlayCircle16 = "PlayCircle16",
PlayCircle20 = "PlayCircle20",
PlayCircle24 = "PlayCircle24",
PlayCircle32 = "PlayCircle32",
PlayFrame = "PlayFrame",
PlayFrame12 = "PlayFrame12",
PlayFrame16 = "PlayFrame16",
PlayFrame20 = "PlayFrame20",
PlayFrame24 = "PlayFrame24",
PlayFrame32 = "PlayFrame32",
Plus = "Plus",
Plus12 = "Plus12",
Plus16 = "Plus16",
Plus20 = "Plus20",
Plus24 = "Plus24",
Plus32 = "Plus32",
PlusBoxStack = "PlusBoxStack",
PlusBoxStack12 = "PlusBoxStack12",
PlusBoxStack16 = "PlusBoxStack16",
PlusBoxStack20 = "PlusBoxStack20",
PlusBoxStack24 = "PlusBoxStack24",
PlusBoxStack32 = "PlusBoxStack32",
PlusCircle = "PlusCircle",
PlusCircle12 = "PlusCircle12",
PlusCircle16 = "PlusCircle16",
PlusCircle20 = "PlusCircle20",
PlusCircle24 = "PlusCircle24",
PlusCircle32 = "PlusCircle32",
PlusFrame = "PlusFrame",
PlusFrame12 = "PlusFrame12",
PlusFrame16 = "PlusFrame16",
PlusFrame20 = "PlusFrame20",
PlusFrame24 = "PlusFrame24",
PlusFrame32 = "PlusFrame32",
Pointout = "Pointout",
Pointout12 = "Pointout12",
Pointout16 = "Pointout16",
Pointout20 = "Pointout20",
Pointout24 = "Pointout24",
Pointout32 = "Pointout32",
Polygon = "Polygon",
Polygon12 = "Polygon12",
Polygon16 = "Polygon16",
Polygon20 = "Polygon20",
Polygon24 = "Polygon24",
Polygon32 = "Polygon32",
Puzzle = "Puzzle",
Puzzle12 = "Puzzle12",
Puzzle16 = "Puzzle16",
Puzzle20 = "Puzzle20",
Puzzle24 = "Puzzle24",
Puzzle32 = "Puzzle32",
QuestionMark = "QuestionMark",
QuestionMark12 = "QuestionMark12",
QuestionMark16 = "QuestionMark16",
QuestionMark20 = "QuestionMark20",
QuestionMark24 = "QuestionMark24",
QuestionMark32 = "QuestionMark32",
QuestionMarkCircle = "QuestionMarkCircle",
QuestionMarkCircle12 = "QuestionMarkCircle12",
QuestionMarkCircle16 = "QuestionMarkCircle16",
QuestionMarkCircle20 = "QuestionMarkCircle20",
QuestionMarkCircle24 = "QuestionMarkCircle24",
QuestionMarkCircle32 = "QuestionMarkCircle32",
RadiusBottomLeft = "RadiusBottomLeft",
RadiusBottomLeft12 = "RadiusBottomLeft12",
RadiusBottomLeft16 = "RadiusBottomLeft16",
RadiusBottomLeft20 = "RadiusBottomLeft20",
RadiusBottomLeft24 = "RadiusBottomLeft24",
RadiusBottomLeft32 = "RadiusBottomLeft32",
RadiusBottomRight = "RadiusBottomRight",
RadiusBottomRight12 = "RadiusBottomRight12",
RadiusBottomRight16 = "RadiusBottomRight16",
RadiusBottomRight20 = "RadiusBottomRight20",
RadiusBottomRight24 = "RadiusBottomRight24",
RadiusBottomRight32 = "RadiusBottomRight32",
RadiusTopLeft = "RadiusTopLeft",
RadiusTopLeft12 = "RadiusTopLeft12",
RadiusTopLeft16 = "RadiusTopLeft16",
RadiusTopLeft20 = "RadiusTopLeft20",
RadiusTopLeft24 = "RadiusTopLeft24",
RadiusTopLeft32 = "RadiusTopLeft32",
RadiusTopRight = "RadiusTopRight",
RadiusTopRight12 = "RadiusTopRight12",
RadiusTopRight16 = "RadiusTopRight16",
RadiusTopRight20 = "RadiusTopRight20",
RadiusTopRight24 = "RadiusTopRight24",
RadiusTopRight32 = "RadiusTopRight32",
RectangleLandscape = "RectangleLandscape",
RectangleLandscape12 = "RectangleLandscape12",
RectangleLandscape16 = "RectangleLandscape16",
RectangleLandscape20 = "RectangleLandscape20",
RectangleLandscape24 = "RectangleLandscape24",
RectangleLandscape32 = "RectangleLandscape32",
RectanglePortraitSquare = "RectanglePortraitSquare",
RectanglePortraitSquare12 = "RectanglePortraitSquare12",
RectanglePortraitSquare16 = "RectanglePortraitSquare16",
RectanglePortraitSquare20 = "RectanglePortraitSquare20",
RectanglePortraitSquare24 = "RectanglePortraitSquare24",
RectanglePortraitSquare32 = "RectanglePortraitSquare32",
Report = "Report",
Report12 = "Report12",
Report16 = "Report16",
Report20 = "Report20",
Report24 = "Report24",
Report32 = "Report32",
Rocket = "Rocket",
Rocket12 = "Rocket12",
Rocket16 = "Rocket16",
Rocket20 = "Rocket20",
Rocket24 = "Rocket24",
Rocket32 = "Rocket32",
Rotate90Left = "Rotate90Left",
Rotate90Left12 = "Rotate90Left12",
Rotate90Left16 = "Rotate90Left16",
Rotate90Left20 = "Rotate90Left20",
Rotate90Left24 = "Rotate90Left24",
Rotate90Left32 = "Rotate90Left32",
Rotate90Right = "Rotate90Right",
Rotate90Right12 = "Rotate90Right12",
Rotate90Right16 = "Rotate90Right16",
Rotate90Right20 = "Rotate90Right20",
Rotate90Right24 = "Rotate90Right24",
Rotate90Right32 = "Rotate90Right32",
Ruler = "Ruler",
Ruler12 = "Ruler12",
Ruler16 = "Ruler16",
Ruler20 = "Ruler20",
Ruler24 = "Ruler24",
Ruler32 = "Ruler32",
ScaleLarge = "ScaleLarge",
ScaleLarge12 = "ScaleLarge12",
ScaleLarge16 = "ScaleLarge16",
ScaleLarge20 = "ScaleLarge20",
ScaleLarge24 = "ScaleLarge24",
ScaleLarge32 = "ScaleLarge32",
ScaleSmall = "ScaleSmall",
ScaleSmall12 = "ScaleSmall12",
ScaleSmall16 = "ScaleSmall16",
ScaleSmall20 = "ScaleSmall20",
ScaleSmall24 = "ScaleSmall24",
ScaleSmall32 = "ScaleSmall32",
Scissors = "Scissors",
Scissors12 = "Scissors12",
Scissors16 = "Scissors16",
Scissors20 = "Scissors20",
Scissors24 = "Scissors24",
Scissors32 = "Scissors32",
SidebarLeft = "SidebarLeft",
SidebarLeft12 = "SidebarLeft12",
SidebarLeft16 = "SidebarLeft16",
SidebarLeft20 = "SidebarLeft20",
SidebarLeft24 = "SidebarLeft24",
SidebarLeft32 = "SidebarLeft32",
SidebarLeftHide = "SidebarLeftHide",
SidebarLeftHide12 = "SidebarLeftHide12",
SidebarLeftHide12Filled = "SidebarLeftHide12Filled",
SidebarLeftHide16 = "SidebarLeftHide16",
SidebarLeftHide16Filled = "SidebarLeftHide16Filled",
SidebarLeftHide20 = "SidebarLeftHide20",
SidebarLeftHide20Filled = "SidebarLeftHide20Filled",
SidebarLeftHide24 = "SidebarLeftHide24",
SidebarLeftHide24Filled = "SidebarLeftHide24Filled",
SidebarLeftHide32 = "SidebarLeftHide32",
SidebarLeftHide32Filled = "SidebarLeftHide32Filled",
SidebarLeftShow = "SidebarLeftShow",
SidebarLeftShow12 = "SidebarLeftShow12",
SidebarLeftShow12Filled = "SidebarLeftShow12Filled",
SidebarLeftShow16 = "SidebarLeftShow16",
SidebarLeftShow16Filled = "SidebarLeftShow16Filled",
SidebarLeftShow20 = "SidebarLeftShow20",
SidebarLeftShow20Filled = "SidebarLeftShow20Filled",
SidebarLeftShow24 = "SidebarLeftShow24",
SidebarLeftShow24Filled = "SidebarLeftShow24Filled",
SidebarLeftShow32 = "SidebarLeftShow32",
SidebarLeftShow32Filled = "SidebarLeftShow32Filled",
SidebarRight = "SidebarRight",
SidebarRight12 = "SidebarRight12",
SidebarRight16 = "SidebarRight16",
SidebarRight20 = "SidebarRight20",
SidebarRight24 = "SidebarRight24",
SidebarRight32 = "SidebarRight32",
SidebarRightHide = "SidebarRightHide",
SidebarRightHide12 = "SidebarRightHide12",
SidebarRightHide12Filled = "SidebarRightHide12Filled",
SidebarRightHide16 = "SidebarRightHide16",
SidebarRightHide16Filled = "SidebarRightHide16Filled",
SidebarRightHide20 = "SidebarRightHide20",
SidebarRightHide20Filled = "SidebarRightHide20Filled",
SidebarRightHide24 = "SidebarRightHide24",
SidebarRightHide24Filled = "SidebarRightHide24Filled",
SidebarRightHide32 = "SidebarRightHide32",
SidebarRightHide32Filled = "SidebarRightHide32Filled",
SidebarRightShow = "SidebarRightShow",
SidebarRightShow12 = "SidebarRightShow12",
SidebarRightShow12Filled = "SidebarRightShow12Filled",
SidebarRightShow16 = "SidebarRightShow16",
SidebarRightShow16Filled = "SidebarRightShow16Filled",
SidebarRightShow20 = "SidebarRightShow20",
SidebarRightShow20Filled = "SidebarRightShow20Filled",
SidebarRightShow24 = "SidebarRightShow24",
SidebarRightShow24Filled = "SidebarRightShow24Filled",
SidebarRightShow32 = "SidebarRightShow32",
SidebarRightShow32Filled = "SidebarRightShow32Filled",
Sketch = "Sketch",
Sketch12 = "Sketch12",
Sketch16 = "Sketch16",
Sketch20 = "Sketch20",
Sketch24 = "Sketch24",
Sketch32 = "Sketch32",
Skip5SecondsBackward = "Skip5SecondsBackward",
Skip5SecondsBackward12 = "Skip5SecondsBackward12",
Skip5SecondsBackward16 = "Skip5SecondsBackward16",
Skip5SecondsBackward20 = "Skip5SecondsBackward20",
Skip5SecondsBackward24 = "Skip5SecondsBackward24",
Skip5SecondsBackward32 = "Skip5SecondsBackward32",
Skip5SecondsForward = "Skip5SecondsForward",
Skip5SecondsForward12 = "Skip5SecondsForward12",
Skip5SecondsForward16 = "Skip5SecondsForward16",
Skip5SecondsForward20 = "Skip5SecondsForward20",
Skip5SecondsForward24 = "Skip5SecondsForward24",
Skip5SecondsForward32 = "Skip5SecondsForward32",
SoundWave = "SoundWave",
SoundWave12 = "SoundWave12",
SoundWave16 = "SoundWave16",
SoundWave20 = "SoundWave20",
SoundWave24 = "SoundWave24",
SoundWave32 = "SoundWave32",
Sparks = "Sparks",
Sparks12 = "Sparks12",
Sparks16 = "Sparks16",
Sparks20 = "Sparks20",
Sparks20Filled = "Sparks20Filled",
Sparks24 = "Sparks24",
Sparks24Filled = "Sparks24Filled",
Sparks32 = "Sparks32",
Sparks32Filled = "Sparks32Filled",
Speaker = "Speaker",
Speaker12 = "Speaker12",
Speaker16 = "Speaker16",
Speaker20 = "Speaker20",
Speaker24 = "Speaker24",
Speaker32 = "Speaker32",
SpeakerOff = "SpeakerOff",
SpeakerOff12 = "SpeakerOff12",
SpeakerOff16 = "SpeakerOff16",
SpeakerOff20 = "SpeakerOff20",
SpeakerOff24 = "SpeakerOff24",
SpeakerOff32 = "SpeakerOff32",
SpeechBubbleDots = "SpeechBubbleDots",
SpeechBubbleDots12 = "SpeechBubbleDots12",
SpeechBubbleDots16 = "SpeechBubbleDots16",
SpeechBubbleDots20 = "SpeechBubbleDots20",
SpeechBubbleDots24 = "SpeechBubbleDots24",
SpeechBubbleDots32 = "SpeechBubbleDots32",
SpeechBubbleEmpty = "SpeechBubbleEmpty",
SpeechBubbleEmpty12 = "SpeechBubbleEmpty12",
SpeechBubbleEmpty16 = "SpeechBubbleEmpty16",
SpeechBubbleEmpty20 = "SpeechBubbleEmpty20",
SpeechBubbleEmpty24 = "SpeechBubbleEmpty24",
SpeechBubbleEmpty32 = "SpeechBubbleEmpty32",
SpeechBubbleQuote = "SpeechBubbleQuote",
SpeechBubbleQuote12 = "SpeechBubbleQuote12",
SpeechBubbleQuote16 = "SpeechBubbleQuote16",
SpeechBubbleQuote20 = "SpeechBubbleQuote20",
SpeechBubbleQuote24 = "SpeechBubbleQuote24",
SpeechBubbleQuote32 = "SpeechBubbleQuote32",
SpeechBubbleStack = "SpeechBubbleStack",
SpeechBubbleStack12 = "SpeechBubbleStack12",
SpeechBubbleStack16 = "SpeechBubbleStack16",
SpeechBubbleStack20 = "SpeechBubbleStack20",
SpeechBubbleStack24 = "SpeechBubbleStack24",
SpeechBubbleStack32 = "SpeechBubbleStack32",
Square = "Square",
Square12 = "Square12",
Square16 = "Square16",
Square20 = "Square20",
Square24 = "Square24",
Square32 = "Square32",
StackHorizontal = "StackHorizontal",
StackHorizontal12 = "StackHorizontal12",
StackHorizontal16 = "StackHorizontal16",
StackHorizontal20 = "StackHorizontal20",
StackHorizontal24 = "StackHorizontal24",
StackHorizontal32 = "StackHorizontal32",
StackHorizontalAltFour = "StackHorizontalAltFour",
StackHorizontalAltFour12 = "StackHorizontalAltFour12",
StackHorizontalAltFour16 = "StackHorizontalAltFour16",
StackHorizontalAltFour20 = "StackHorizontalAltFour20",
StackHorizontalAltFour24 = "StackHorizontalAltFour24",
StackHorizontalAltFour32 = "StackHorizontalAltFour32",
StackHorizontalAltThree = "StackHorizontalAltThree",
StackHorizontalAltThree12 = "StackHorizontalAltThree12",
StackHorizontalAltThree16 = "StackHorizontalAltThree16",
StackHorizontalAltThree20 = "StackHorizontalAltThree20",
StackHorizontalAltThree24 = "StackHorizontalAltThree24",
StackHorizontalAltThree32 = "StackHorizontalAltThree32",
StackHorizontalAltTwo = "StackHorizontalAltTwo",
StackHorizontalAltTwo12 = "StackHorizontalAltTwo12",
StackHorizontalAltTwo16 = "StackHorizontalAltTwo16",
StackHorizontalAltTwo20 = "StackHorizontalAltTwo20",
StackHorizontalAltTwo24 = "StackHorizontalAltTwo24",
StackHorizontalAltTwo32 = "StackHorizontalAltTwo32",
StackVertical = "StackVertical",
StackVertical12 = "StackVertical12",
StackVertical16 = "StackVertical16",
StackVertical20 = "StackVertical20",
StackVertical24 = "StackVertical24",
StackVertical32 = "StackVertical32",
Star = "Star",
Star12 = "Star12",
Star12Filled = "Star12Filled",
Star16 = "Star16",
Star16Filled = "Star16Filled",
Star20 = "Star20",
Star20Filled = "Star20Filled",
Star24 = "Star24",
Star24Filled = "Star24Filled",
Star32 = "Star32",
Star32Filled = "Star32Filled",
Storybook = "Storybook",
Storybook12 = "Storybook12",
Storybook16 = "Storybook16",
Storybook20 = "Storybook20",
Storybook24 = "Storybook24",
Storybook32 = "Storybook32",
StrikethroughBox = "StrikethroughBox",
StrikethroughBox12 = "StrikethroughBox12",
StrikethroughBox16 = "StrikethroughBox16",
StrikethroughBox20 = "StrikethroughBox20",
StrikethroughBox24 = "StrikethroughBox24",
StrikethroughBox32 = "StrikethroughBox32",
Subscript = "Subscript",
Subscript12 = "Subscript12",
Subscript16 = "Subscript16",
Subscript20 = "Subscript20",
Subscript24 = "Subscript24",
Subscript32 = "Subscript32",
Suitcase = "Suitcase",
Suitcase12 = "Suitcase12",
Suitcase16 = "Suitcase16",
Suitcase20 = "Suitcase20",
Suitcase24 = "Suitcase24",
Suitcase32 = "Suitcase32",
SuitcaseTag = "SuitcaseTag",
SuitcaseTag12 = "SuitcaseTag12",
SuitcaseTag16 = "SuitcaseTag16",
SuitcaseTag20 = "SuitcaseTag20",
SuitcaseTag24 = "SuitcaseTag24",
SuitcaseTag32 = "SuitcaseTag32",
Superscript = "Superscript",
Superscript12 = "Superscript12",
Superscript16 = "Superscript16",
Superscript20 = "Superscript20",
Superscript24 = "Superscript24",
Superscript32 = "Superscript32",
Table = "Table",
Table12 = "Table12",
Table16 = "Table16",
Table20 = "Table20",
Table24 = "Table24",
Table32 = "Table32",
Target = "Target",
Target12 = "Target12",
Target16 = "Target16",
Target20 = "Target20",
Target24 = "Target24",
Target32 = "Target32",
TextAlignmentCentre = "TextAlignmentCentre",
TextAlignmentCentre12 = "TextAlignmentCentre12",
TextAlignmentCentre16 = "TextAlignmentCentre16",
TextAlignmentCentre20 = "TextAlignmentCentre20",
TextAlignmentCentre24 = "TextAlignmentCentre24",
TextAlignmentCentre32 = "TextAlignmentCentre32",
TextAlignmentJustify = "TextAlignmentJustify",
TextAlignmentJustify12 = "TextAlignmentJustify12",
TextAlignmentJustify16 = "TextAlignmentJustify16",
TextAlignmentJustify20 = "TextAlignmentJustify20",
TextAlignmentJustify24 = "TextAlignmentJustify24",
TextAlignmentJustify32 = "TextAlignmentJustify32",
TextAlignmentLeft = "TextAlignmentLeft",
TextAlignmentLeft12 = "TextAlignmentLeft12",
TextAlignmentLeft16 = "TextAlignmentLeft16",
TextAlignmentLeft20 = "TextAlignmentLeft20",
TextAlignmentLeft24 = "TextAlignmentLeft24",
TextAlignmentLeft32 = "TextAlignmentLeft32",
TextAlignmentRight = "TextAlignmentRight",
TextAlignmentRight12 = "TextAlignmentRight12",
TextAlignmentRight16 = "TextAlignmentRight16",
TextAlignmentRight20 = "TextAlignmentRight20",
TextAlignmentRight24 = "TextAlignmentRight24",
TextAlignmentRight32 = "TextAlignmentRight32",
TextBoxStack = "TextBoxStack",
TextBoxStack12 = "TextBoxStack12",
TextBoxStack16 = "TextBoxStack16",
TextBoxStack20 = "TextBoxStack20",
TextBoxStack24 = "TextBoxStack24",
TextBoxStack32 = "TextBoxStack32",
TextBrackets = "TextBrackets",
TextBrackets12 = "TextBrackets12",
TextBrackets16 = "TextBrackets16",
TextBrackets20 = "TextBrackets20",
TextBrackets24 = "TextBrackets24",
TextBrackets32 = "TextBrackets32",
TextColumnBreak = "TextColumnBreak",
TextColumnBreak12 = "TextColumnBreak12",
TextColumnBreak16 = "TextColumnBreak16",
TextColumnBreak20 = "TextColumnBreak20",
TextColumnBreak24 = "TextColumnBreak24",
TextColumnBreak32 = "TextColumnBreak32",
TextColumns = "TextColumns",
TextColumns12 = "TextColumns12",
TextColumns16 = "TextColumns16",
TextColumns20 = "TextColumns20",
TextColumns24 = "TextColumns24",
TextColumns32 = "TextColumns32",
TextFormatBold = "TextFormatBold",
TextFormatBold12 = "TextFormatBold12",
TextFormatBold16 = "TextFormatBold16",
TextFormatBold20 = "TextFormatBold20",
TextFormatBold24 = "TextFormatBold24",
TextFormatBold32 = "TextFormatBold32",
TextFormatItalic = "TextFormatItalic",
TextFormatItalic12 = "TextFormatItalic12",
TextFormatItalic16 = "TextFormatItalic16",
TextFormatItalic20 = "TextFormatItalic20",
TextFormatItalic24 = "TextFormatItalic24",
TextFormatItalic32 = "TextFormatItalic32",
TextFormatStrikethrough = "TextFormatStrikethrough",
TextFormatStrikethrough12 = "TextFormatStrikethrough12",
TextFormatStrikethrough16 = "TextFormatStrikethrough16",
TextFormatStrikethrough20 = "TextFormatStrikethrough20",
TextFormatStrikethrough24 = "TextFormatStrikethrough24",
TextFormatStrikethrough32 = "TextFormatStrikethrough32",
TextFormatUnderline = "TextFormatUnderline",
TextFormatUnderline12 = "TextFormatUnderline12",
TextFormatUnderline16 = "TextFormatUnderline16",
TextFormatUnderline20 = "TextFormatUnderline20",
TextFormatUnderline24 = "TextFormatUnderline24",
TextFormatUnderline32 = "TextFormatUnderline32",
TextIndent = "TextIndent",
TextIndent12 = "TextIndent12",
TextIndent16 = "TextIndent16",
TextIndent20 = "TextIndent20",
TextIndent24 = "TextIndent24",
TextIndent32 = "TextIndent32",
TextOutdent = "TextOutdent",
TextOutdent12 = "TextOutdent12",
TextOutdent16 = "TextOutdent16",
TextOutdent20 = "TextOutdent20",
TextOutdent24 = "TextOutdent24",
TextOutdent32 = "TextOutdent32",
ThumbsDown = "ThumbsDown",
ThumbsDown12 = "ThumbsDown12",
ThumbsDown12Filled = "ThumbsDown12Filled",
ThumbsDown16 = "ThumbsDown16",
ThumbsDown16Filled = "ThumbsDown16Filled",
ThumbsDown20 = "ThumbsDown20",
ThumbsDown20Filled = "ThumbsDown20Filled",
ThumbsDown24 = "ThumbsDown24",
ThumbsDown24Filled = "ThumbsDown24Filled",
ThumbsDown32 = "ThumbsDown32",
ThumbsDown32Filled = "ThumbsDown32Filled",
ThumbsUp = "ThumbsUp",
ThumbsUp12 = "ThumbsUp12",
ThumbsUp12Filled = "ThumbsUp12Filled",
ThumbsUp16 = "ThumbsUp16",
ThumbsUp16Filled = "ThumbsUp16Filled",
ThumbsUp20 = "ThumbsUp20",
ThumbsUp20Filled = "ThumbsUp20Filled",
ThumbsUp24 = "ThumbsUp24",
ThumbsUp24Filled = "ThumbsUp24Filled",
ThumbsUp32 = "ThumbsUp32",
ThumbsUp32Filled = "ThumbsUp32Filled",
TrashBin = "TrashBin",
TrashBin12 = "TrashBin12",
TrashBin16 = "TrashBin16",
TrashBin20 = "TrashBin20",
TrashBin24 = "TrashBin24",
TrashBin32 = "TrashBin32",
Triangle = "Triangle",
Triangle12 = "Triangle12",
Triangle16 = "Triangle16",
Triangle20 = "Triangle20",
Triangle24 = "Triangle24",
Triangle32 = "Triangle32",
Twitter = "Twitter",
Twitter12 = "Twitter12",
Twitter16 = "Twitter16",
Twitter20 = "Twitter20",
Twitter24 = "Twitter24",
Twitter32 = "Twitter32",
Typography = "Typography",
Typography12 = "Typography12",
Typography16 = "Typography16",
Typography20 = "Typography20",
Typography24 = "Typography24",
Typography32 = "Typography32",
TypographyBox = "TypographyBox",
TypographyBox12 = "TypographyBox12",
TypographyBox16 = "TypographyBox16",
TypographyBox20 = "TypographyBox20",
TypographyBox24 = "TypographyBox24",
TypographyBox32 = "TypographyBox32",
TypographyCase = "TypographyCase",
TypographyCase12 = "TypographyCase12",
TypographyCase16 = "TypographyCase16",
TypographyCase20 = "TypographyCase20",
TypographyCase24 = "TypographyCase24",
TypographyCase32 = "TypographyCase32",
TypographyMultiple = "TypographyMultiple",
TypographyMultiple12 = "TypographyMultiple12",
TypographyMultiple16 = "TypographyMultiple16",
TypographyMultiple20 = "TypographyMultiple20",
TypographyMultiple24 = "TypographyMultiple24",
TypographyMultiple32 = "TypographyMultiple32",
Vimeo = "Vimeo",
Vimeo12 = "Vimeo12",
Vimeo16 = "Vimeo16",
Vimeo20 = "Vimeo20",
Vimeo24 = "Vimeo24",
Vimeo32 = "Vimeo32",
Wand = "Wand",
Wand12 = "Wand12",
Wand16 = "Wand16",
Wand20 = "Wand20",
Wand24 = "Wand24",
Wand32 = "Wand32",
WorkflowLanes = "WorkflowLanes",
WorkflowLanes12 = "WorkflowLanes12",
WorkflowLanes16 = "WorkflowLanes16",
WorkflowLanes20 = "WorkflowLanes20",
WorkflowLanes24 = "WorkflowLanes24",
WorkflowLanes32 = "WorkflowLanes32",
WorkflowShapes = "WorkflowShapes",
WorkflowShapes12 = "WorkflowShapes12",
WorkflowShapes16 = "WorkflowShapes16",
WorkflowShapes20 = "WorkflowShapes20",
WorkflowShapes24 = "WorkflowShapes24",
WorkflowShapes32 = "WorkflowShapes32"
        };
    